import {
  MarkDownTokenParser,
  fetchTokens,
  escapeAttr,
} from "./markdown_token_parser.js";
import {
  darkenNavBar,
  loadNavBar,
  loadFooter,
  footerElements,
  setupNavBarLinks,
  loadDefaultLanguage,
  setLanguage,
} from "./static.js";

// Import internationalization
import headerFi from "bundle-text:../public/content-md/kendo-info/header-fi.md";
import headerSv from "bundle-text:../public/content-md/kendo-info/header-sv.md";
import headerEn from "bundle-text:../public/content-md/kendo-info/header-en.md";
import equipmentFi from "bundle-text:../public/content-md/kendo-info/equipment-fi.md";
import equipmentSv from "bundle-text:../public/content-md/kendo-info/equipment-sv.md";
import equipmentEn from "bundle-text:../public/content-md/kendo-info/equipment-en.md";
import videosFi from "bundle-text:../public/content-md/kendo-info/videos-fi.md";
import videosSv from "bundle-text:../public/content-md/kendo-info/videos-sv.md";
import videosEn from "bundle-text:../public/content-md/kendo-info/videos-en.md";
import navbarFi from "bundle-text:../public/content-md/navbar/navbar-fi.md";
import navbarSv from "bundle-text:../public/content-md/navbar/navbar-sv.md";
import navbarEn from "bundle-text:../public/content-md/navbar/navbar-en.md";
import footerFi from "bundle-text:../public/content-md/footer/footer-fi.md";
import footerSv from "bundle-text:../public/content-md/footer/footer-sv.md";
import footerEn from "bundle-text:../public/content-md/footer/footer-en.md";

const markdownContent = {
  fi: {
    navbar: navbarFi,
    header: headerFi,
    equipment: equipmentFi,
    videos: videosFi,
    footer: footerFi,
  },
  sv: {
    navbar: navbarSv,
    header: headerSv,
    equipment: equipmentSv,
    videos: videosSv,
    footer: footerSv,
  },
  en: {
    navbar: navbarEn,
    header: headerEn,
    equipment: equipmentEn,
    videos: videosEn,
    footer: footerEn,
  },
};

async function renderContent(lang = "fi") {
  const navbarContent = new MarkDownTokenParser(markdownContent[lang].navbar);
  const headerContent = new MarkDownTokenParser(markdownContent[lang].header);
  const equipmentContent = new MarkDownTokenParser(
    markdownContent[lang].equipment
  );
  const videosContent = new MarkDownTokenParser(markdownContent[lang].videos);
  const footerContent = new MarkDownTokenParser(markdownContent[lang].footer);

  await navbarContent.render();
  await headerContent.render();
  await equipmentContent.render();
  await videosContent.render();
  await footerContent.render();
}

document.addEventListener("DOMContentLoaded", () => {
  loadNavBar()
    .then(darkenNavBar())
    .then(() => loadFooter())
    .then(() => setupNavBarLinks())
    .then(() => loadDefaultLanguage())
    .then((lang) => renderContent(lang))
    .then(() => {
      const languageButtons = document.querySelector("#navbar-changeLanguage");
      const languageFlags = document.querySelectorAll(".navbar-language-flag");
      // console.log(languageButtons);
      languageButtons.addEventListener("click", (e) => {
        e.preventDefault();
        // console.log("Ping");
        if (e.target.id === "changeFinnish") {
          // console.log("changeFinnish");
          renderContent("fi");
          setLanguage("fi");
          languageFlags.forEach((flag) => {
            flag.classList.remove("active");
          });
          e.target.classList.add("active");
        } else if (e.target.id === "changeSwedish") {
          // console.log("changeSwedish");
          renderContent("sv");
          setLanguage("sv");
          languageFlags.forEach((flag) => {
            flag.classList.remove("active");
          });
          e.target.classList.add("active");
        } else if (e.target.id === "changeEnglish") {
          // console.log("changeEnglish");
          renderContent("en");
          setLanguage("en");
          languageFlags.forEach((flag) => {
            flag.classList.remove("active");
          });
          e.target.classList.add("active");
        }
      });
    });
});
